import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppService } from 'src/app/app.service';
import { CurrenciesInterface } from '../../interfaces/deposit.interface';
import { LocalStorageService } from '../../service/localstorage.service';
interface CurrencyDisplay {
  [uid: string]: string[];
}
@UntilDestroy()
@Component({
  selector: 'app-edit-currency',
  templateUrl: './edit-currency.component.html',
  styleUrls: ['./edit-currency.component.scss'],
  animations: [
    trigger('toggle', [
      transition('* => *', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('0.3s ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
    ]),
  ],
})
export class EditCurrencyComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { currencies: CurrenciesInterface[] },
    private dialogRef: MatDialogRef<EditCurrencyComponent>,
    private localStorageService: LocalStorageService,
    private appService: AppService
  ) {}
  currentCurrencyData?: CurrenciesInterface;
  keyword = '';
  selectIndex = 0;
  tabToggleAnimateTick = 0;
  isSortAZ: boolean = true;
  /** userUid 默认为-1， 用于用户未登录的时候判断*/
  userUid: string = '-1';

  ngOnInit() {
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe(v => {
      if (v) this.userUid = v?.uid as string;
    });
    //订阅当前货币
    this.appService.currentCurrency$.pipe(untilDestroyed(this)).subscribe(v => {
      this.currentCurrencyData = v;
    });
  }

  selectTab(index: number) {
    // 触发动画
    this.tabToggleAnimateTick = Math.random();
    this.selectIndex = index;
  }

  saveCurrencyDisplay() {
    const selectedArr: string[] = [];
    this.data.currencies.forEach(x => {
      if (x.display) selectedArr.push(x.currency);
    });
    const currencyDisplay: CurrencyDisplay = this.localStorageService.currencyDisplay || {};
    this.localStorageService.currencyDisplay = {
      ...currencyDisplay,
      [this.userUid]: selectedArr,
    };
  }

  clickItem(item: CurrenciesInterface) {
    if (item.currency === this.currentCurrencyData?.currency) return;
    item.display = !item.display;
    this.saveCurrencyDisplay();
  }

  close() {
    this.dialogRef?.close();
  }
}
